export const SET_LEAGUE_RANKING = "SET_LEAGUE_RANKING";
